Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    paragraph = _STYLES$useStyles.paragraph,
    bp = _STYLES$useStyles.bp,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var label = Object.assign({}, fontBold, {
    width: '100%',
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    textAlign: 'center'
  });
  if (bp.desktop) {
    label.fontSize = _styles.STYLES.fontSize.normal;
    label.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var styles = _reactNative.StyleSheet.create({
    container: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: spacing.xl
    },
    labelContainer: {
      width: '100%',
      maxWidth: _styles.STYLES.grid.maxInputWidth,
      alignSelf: 'center',
      marginBottom: spacing.normal
    },
    label: label,
    description: Object.assign({}, fontRegular, {
      color: paragraph.color,
      fontSize: _styles.STYLES.fontSize.s,
      lineHeight: _styles.STYLES.lineHeight.s,
      textAlign: 'center',
      marginTop: spacing.xxs
    })
  });
  return {
    styles: styles
  };
};